"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _auth0Js = require("auth0-js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// if promise hasn't been polyfilled polyfill it just for this file
var _Promise = typeof Promise === "undefined" ? require("es6-promise").Promise : Promise;

// https://auth0.com/docs/api-auth/tutorials/authorization-code-grant

var AuthorizationCodeGrant = function () {
  function AuthorizationCodeGrant() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        clientID = _ref.clientID,
        _ref$redirectRoute = _ref.redirectRoute,
        redirectRoute = _ref$redirectRoute === undefined ? "" : _ref$redirectRoute,
        _ref$domain = _ref.domain,
        domain = _ref$domain === undefined ? "cimpress.auth0.com" : _ref$domain,
        _ref$audience = _ref.audience,
        audience = _ref$audience === undefined ? "https://api.cimpress.io/" : _ref$audience,
        _ref$scope = _ref.scope,
        scope = _ref$scope === undefined ? "offline_access" : _ref$scope;

    _classCallCheck(this, AuthorizationCodeGrant);

    this.redirectUri = window.location.origin + redirectRoute;
    this.auth0 = new _auth0Js.WebAuth({
      clientID: clientID,
      redirectUri: this.redirectUri,
      domain: domain,
      audience: audience,
      scope: scope,
      responseType: "code"
    });
  }

  _createClass(AuthorizationCodeGrant, [{
    key: "login",
    value: function login() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$nextUri = _ref2.nextUri,
          nextUri = _ref2$nextUri === undefined ? window.location.href : _ref2$nextUri;

      var state = btoa(nextUri);

      this.auth0.authorize({ state: state });
      return _Promise.resolve();
    }
  }, {
    key: "handleAuthentication",
    value: function handleAuthentication() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$performRedirect = _ref3.performRedirect,
          performRedirect = _ref3$performRedirect === undefined ? true : _ref3$performRedirect;

      var authorizationCode = localStorage.getItem("authorizationCode");
      var nextUri = localStorage.getItem("nextUri");

      if (authorizationCode && nextUri) {
        localStorage.removeItem("authorizationCode");
        localStorage.removeItem("nextUri");

        return _Promise.resolve({ authorizationCode: authorizationCode, redirectUri: this.redirectUri, nextUri: nextUri });
      } else if (this.wasAuth0Redirect()) {
        return this.handleRedirect({ performRedirect: performRedirect });
      }

      return _Promise.resolve({});
    }
  }, {
    key: "wasAuth0Redirect",
    value: function wasAuth0Redirect() {
      var parsedUrl = new URL(window.location.href);
      return parsedUrl.searchParams.get("code") && parsedUrl.searchParams.get("state");
    }
  }, {
    key: "handleRedirect",
    value: function handleRedirect(_ref4) {
      var performRedirect = _ref4.performRedirect;

      var parsedUrl = new URL(window.location.href);
      var authorizationCode = parsedUrl.searchParams.get("code");
      var state = parsedUrl.searchParams.get("state");
      var nextUri = atob(state);

      if (performRedirect) {
        localStorage.setItem("authorizationCode", authorizationCode);
        localStorage.setItem("nextUri", nextUri);
        window.location = nextUri || "/";

        return _Promise.resolve({});
      }

      return _Promise.resolve({ authorizationCode: authorizationCode, redirectUri: this.redirectUri, nextUri: nextUri });
    }
  }]);

  return AuthorizationCodeGrant;
}();

exports.default = AuthorizationCodeGrant;
//# sourceMappingURL=authorizationcodegrant.js.map
